import React from 'react';
import { Grid } from '@mui/material';

interface GridContainerProps {
  children: React.ReactNode;
  spacing?: number | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  sx?: any;
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
}

/**
 * GridContainer is a wrapper component around Material UI's Grid
 * that works around the 'container' prop type issues in MUI v7
 */
const GridContainer: React.FC<GridContainerProps> = ({ children, ...props }) => {
  // @ts-ignore - This suppresses the TypeScript error for the 'container' prop
  return <Grid container {...props}>{children}</Grid>;
};

export default GridContainer; 